import React, { useState, useRef, useEffect, useCallback } from "react";
import debounce from "lodash/debounce";

import { Input } from "../ui";
import { useEventsStore } from "../state";

export default function SearchBar() {
  const { setSearchTerm, showSearch, setShowSearch } = useEventsStore();

  const [search, setSearch] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef(null);

  // Debounce the search term input to avoid too many updates
  const debouncedSetSearchTerm = useCallback(
    debounce((term) => {
      setSearchTerm(term);
    }, 1000),
    [setSearchTerm]
  );

  // Clean up the debounced function on unmount
  useEffect(() => {
    return () => {
      debouncedSetSearchTerm.cancel();
    };
  }, [debouncedSetSearchTerm]);

  // Set search term in store when search term changes
  useEffect(() => {
    debouncedSetSearchTerm(search);
  }, [search, debouncedSetSearchTerm]);

  // When showSearch changes from false to true, focus the input
  useEffect(() => {
    if (showSearch) {
      setIsFocused(true);
      if (inputRef.current) {
        inputRef.current.focus();
      }
    } else {
      setIsFocused(false);
    }
  }, [showSearch]);

  return (
    <div
      // className={` ${
      //   !showSearch ? "invisible" : "visible"
      // } !py-4 !md:py-6 container flex mx-auto container-md-padding navbar__border-visible  border-l border-r gap-4 items-center absolute bg-white`}
      className={`transition-opacity duration-300 ease-in-out !py-4 !md:py-6 container flex mx-auto container-md-padding navbar__border-visible border-l border-r gap-4 items-center absolute bg-white ${
        !showSearch ? "opacity-0 pointer-events-none" : "opacity-100"
      }`}
    >
      <div className="text-sm md:text-lg">Search:</div>
      <div className="text-sm md:text-lg flex-grow flex justify-between">
        <Input
          className="w-full !text-sm !md:text-lg !py-0 !border-none"
          placeholder="Name, city, address, etc..."
          ref={(ref) => (inputRef.current = ref)}
          onChange={(e) => {
            setSearch(e.target.value);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              setIsFocused(false);
              setSearchTerm(search);
            }
            if (e.key === "Escape") {
              setIsFocused(false);
              setShowSearch(false);
            }
          }}
          onFocus={() => {
            setIsFocused(true);
          }}
          onBlur={() => {
            setIsFocused(false);
          }}
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck="false"
          autoFocus={isFocused}
          value={search}
        />
        <div className="text-sm md:text-lg">
          <button
            className="text-gray-500 hover:text-gray-700 tracking-widest font-semibold"
            onClick={() => {
              setSearch("");
              setSearchTerm("");
              setShowSearch(false);
            }}
          >
            Clear
          </button>
        </div>
      </div>
    </div>
  );
}
